export const colors = {
    textColor: "#111111",
    secondaryTextColor: "#FEF9F9",
    accentColor: "#FFC107",
    whiteColor: "#FDF7F2",
    lightBlueColor: "#CCE4FB",
    blueColor: "#54ADFF",
    gradientBlueColor: "linear-gradient(to left, #419EF1, #9BD0FF)",
    redErrorColor: "#F43F5E",
    greenStepSuccessColor: "#00C3AD",
    blackColor: "#000000",
    textButtonColor: "#FEF9F9",
    inputTextColor: "#888888",
    whiteBgColor: "#FFFFFF",
}